export const LD_REACTIIVE = {
  '@context': 'https://schema.org',
  '@type': 'Person',
  name: 'Enzo Manuel Mangano',
  url: 'https://reactiive.io',
  image: 'https://reactiive.io/pfp.png',
  sameAs: [
    'https://x.com/reactiive_',
    'https://twitter.com/reactiive_',
    'https://www.linkedin.com/in/enzomanuelmangano',
    'https://github.com/enzomanuelmangano',
    'https://www.youtube.com/@reactiive',
  ],
};
